import { cleanupFeatures } from "./cleanup"
import { getPolygons } from "./polygons"
import { IMapTopologyService } from "./topo/types"
import { ol_Feature, ol_geom } from "@omnia/exports/openlayers";

interface ZoneProperties {
    readonly area: number
    readonly feature: ol_Feature
}

export function mergeZones<Zone extends ZoneProperties>(
    layer: { zones: Zone[] },
    isSelected: (zone: Zone) => boolean,
    outerBoundary: ol_geom.Geometry,
    topo: IMapTopologyService,
    removeZones: (zones: Zone[]) => void
): Zone | false {

    const zones = layer.zones.filter(isSelected).sort((z1, z2) => z2.area - z1.area)

    let mergedGeometry: ol_geom.Geometry

    // If an outer boundary was provided, and all zones in the layer are selected to be merged,
    // then we can reuse the outer boundary as the merge result
    if (outerBoundary && (zones.length == layer.zones.length)) {

        mergedGeometry = outerBoundary

    }
    else {

        const geometries = zones.map(g => g.feature.getGeometry())

        const getUnion = (buffer = 0) => {

            const inputs = buffer
                ? geometries.map(g => topo.buffer(g, buffer))
                : geometries

            const r = topo.union(inputs)

            const unionParts = r
                ? getPolygons(r.getOpenLayersGeometry())
                : []

            return (unionParts.length == 1) ? unionParts[0] : false

        }

        const union = getUnion(0) || getUnion(0.01)

        if (union === false) {
            return false
        }

        mergedGeometry = union

    }

    const target = zones[0]

    removeZones(zones.slice(1))

    target.feature.setGeometry(mergedGeometry)

    cleanupFeatures(layer.zones.map(z => z.feature))

    return target

}
